import { IGameObjectType, IKeyStringArrayDict } from "@/types/GlobalTypes";
import { getBasePcode } from "./gamePcode";

export default function fillRoadmapFilters(games: IGameObjectType): void {
	//Roadmap filters
	const filters: IKeyStringArrayDict = {
		"m20": ["circle-square-others"],
		"p6" : ["red-black", "odd-even", "small-big"],
		"p12": ["small-big", "odd-even"],
		"m10": ["head-tail", "left-right"],
		"m11": ["red-white"],
		"m13": ["small-big"],
		"m16": ["player-banker", "odd-even", "small-big"],
		"m22": ["bead-road"],
		"m32": ["player-tie-banker"],
		"m39": ["red-tie-blue"]
	};

	//Duplicate same filters
	filters.m36 = filters.m35 = filters.m6 = filters.p9 = filters.p7 = filters.m14 = filters.p6;
	filters.m37 = filters.m8 = filters.m31 = filters.p12;
	filters.m23 = filters.m25 = filters.m28 = filters.m38 = filters.m40 = filters.m22;

	for (const pcode in games) {
		const basePcode = getBasePcode(pcode);

		if (filters[basePcode])
			games[pcode].roadmapFilters = filters[basePcode];
	}
	//End of roadmap filters
}